<template>
  <div class="cash-withdrawal">
    <div class="wrapper">
      <div  class="list">

        <div class="item acea-row row-between-wrapper">
          <div class="name">选择账户</div>
          <div class="input">
            <select v-model="post.extract_field" @change='extractType'>
              <option
                      v-for="(text, index) in transferType"
                      :value="index"
                      :key="index"
              >
                {{ text }}
              </option>
            </select>

          </div>
        </div>

        <div class="item acea-row row-between-wrapper">
          <div class="name">转入用户</div>
          <div class="input">
            <input placeholder="请输入对方个人账号" v-model="post.account" @blur="getOtherAccount"  />
          </div>
        </div>
        <div class="tip" style="color:red;">{{other_nickname}}</div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">转账金额</div>
          <div class="input">
            <input :placeholder="'最低转账金额' + minPrice" v-model="post.money" />
          </div>
        </div>

        <div class="tip">当前可转账金额: {{ commissionCount }}</div>
        <div class="bnt bg-color-red" @click="submitted">转账</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTransfer, getOtherAccount,postTransferInfo } from "../../../api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";

export default {
  name: "Transfer",
  components: {},
  props: {},
  data: function() {
    return {
      post: {
          account: "",
          money: "",
          extract_field:'',
      },
        account: "",
        money: "",

        transferType:[],
        user:[],
      other_nickname:'',
      commissionCount: 0,
        minPrice:0
    };
  },
    mounted: function() {
        this.getTransfer();
    },
    watch: {
        $route(n) {
            if (n.name == "Transfer") {
                this.getTransfer();
            }
        }
    },
  methods: {
      getTransfer: function() {
        let that = this;
          getTransfer().then(
          res => {
            that.commissionCount = res.data.user[res.data.extract_field];
            that.minPrice = res.data.minPrice;
            that.transferType = res.data.transferType;
            that.post.extract_field = res.data.extract_field;
            that.user = res.data.user;
          },
          function(err) {
            that.$dialog.message(err.msg);
          }
        );
      },
      extractType:function(){
          this.commissionCount =this.user[this.post.extract_field];
      },
      getOtherAccount: function() {
        let that = this,account = that.post.account;
        if(account!='') {
          getOtherAccount(
                  {
                    'account': account
                  }
          ).then(
                  res => {
                    that.other_nickname = res.data.other_nickname;
                  },
                  err => {
                    that.$dialog.message(err.msg);
                  }
          );
        }
      },
    async submitted() {
      let account = this.post.account,
        money = this.post.money,
          extract_field=this.post.extract_field,
        that = this;
      if (parseFloat(money) > parseFloat(that.commissionCount) || parseFloat(that.commissionCount) == 0) return that.$dialog.message("余额不足");
      if (parseFloat(money) < parseFloat(that.minPrice)) return that.$dialog.message("最低转账金额" + that.minPrice);

        try {
            await this.$validator({
                account: [required.message("转入个人账号")],
                money: [required.message("转账金额")],
            }).validate({ account, money });
            let save = {
                account: account,
                money: money,
                extract_field:extract_field,
            };
            that.save(save);
        } catch (e) {
            return validatorDefaultCatch(e);
        }

    },
    save: function(info) {
      postTransferInfo(info).then(
        res => {
          this.$dialog.message(res.msg);
          this.$router.push({ path: "/user/transferAudit" });
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
